// src/redux/searchCustomerSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

// Async thunk to call API
export const searchCustomer = createAsyncThunk<
  any,
  string,
  { rejectValue: string }
>(
  "customer/searchCustomer",
  async (customername, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/GetSearchCustomer`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ customername }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return (await response.json()) as any;
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      } else {
        return rejectWithValue("An unknown error occurred");
      }
    }
  }
);

interface Customer {
  shopify_cust_id: string | null;
  user_name: string;
  email: string | null;
  phone: string | null;
}

interface SearchCustomerState {
  data: any;
  loading: boolean;
  error: string | null;
  selectedCustomer: Customer | null;
}

const initialState: SearchCustomerState = {
  data: null,
  loading: false,
  error: null,
  selectedCustomer: null,
};

const searchCustomerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setSelectedCustomer(state, action: PayloadAction<Customer>) {
      state.selectedCustomer = action.payload;
    },
    clearSelectedCustomer(state) {
      state.selectedCustomer = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchCustomer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(searchCustomer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || null;
      });
  },
});

export const { setSelectedCustomer, clearSelectedCustomer } =
  searchCustomerSlice.actions;

export default searchCustomerSlice.reducer;